import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index'
import main from '@/pages/home'
// import SecondhandRoomDetail from "@/pages/";
import OfficebuildList from '@/pages/office/OfficeBuildingList'//楼盘;
import OfficeBuildingListSale from '@/pages/office/OfficeBuildingListSale'//楼盘售卖;
import OfficeBuildingListRealEstate from '@/pages/office/OfficeBuildingListRealEstate'//楼盘;
import officemmdetail from '@/pages/office/officemmdetail'//买卖详细;
import officeLeaseDetail from "@/pages/office/officeLeaseDetail"//租赁详细;
import secondHandList from "@/pages/secondHand/secondHandList";//二手房
import SecondhandRoomDetail from "@/pages/secondHand/SecondhandRoomDetail";//二手房
import newhouseList from '@/pages/newhouse/newhouseList';//新房列表
import newhouseDetail from '@/pages/newhouse/newhouseDetail';
import RentingRoom from '@/pages/Renting/RentingRoom';//新房列表
import builsDetail from '../pages/office/officeBuildDetail';//楼盘
import entrust from '@/pages/entrust/entrust';//委托
import entrustcz from '@/pages/entrust/entrustcz';
import entrustcs from '@/pages/entrust/entrustcs/';
import entrustmf from '@/pages/entrust/entrustmf/';
import entrustzf from '@/pages/entrust/entrustzf';

import aboutUs1 from '@/pages/aboutUs'
import aboutus from '@/pages/aboutUsList/aboutus'
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '/main',
      name: 'main',
      component: main,
      redirect: 'secondHandList',
      children: [
        {
          path: '/secondHandList',
          name: 'secondHandList',
          component: secondHandList,
          meta:{
            title:'二手房'
          },
        },
        {
          path:'/SecondhandRoomDetail',
          name:'SecondhandRoomDetail',
          component: SecondhandRoomDetail,
          meta:{
            title:'二手房'
          },
        },
        {
          path:'/officeLeaseDetail',
          name:'officeLeaseDetail',
          component: officeLeaseDetail,
          meta:{
            title:'写字楼'
          },
        },
        {
          path: '/OfficebuildList',
          name: 'OfficebuildList',
          component: OfficebuildList,
          meta:{
            title:'写字楼'
          },
        },
        {
          path: '/OfficeBuildingListSale',
          name: 'OfficeBuildingListSale',
          component: OfficeBuildingListSale,
          meta:{
            title:'写字楼出售'
          },
        },
        {
          path: '/OfficeBuildingListRealEstate',
          name: 'OfficeBuildingListRealEstate',
          component: OfficeBuildingListRealEstate,
          meta:{
            title:'楼盘'
          },
        },
        
        {
          path: '/officemmdetail',
          name: 'officemmdetail',
          component: officemmdetail,
          meta:{
            title:'写字楼'
          },
        },
        {
          path: '/builsDetail',
          name: 'builsDetail',
          component: builsDetail,
          meta:{
            title:'写字楼'
          },
        },
        
        {
          path: '/newhouseList',
          name: 'newhouseList',
          component: newhouseList,
          meta:{
            title:'新房'
          },
        },
        {
          path: '/newhouseDetail',
          name: 'newhouseDetail',
          component: newhouseDetail,
          meta:{
            title:'新房详情'
          },
        },
        {
          path: '/RentingRoom',
          name: 'RentingRoom',
          component: RentingRoom,
          meta:{
            title:'租房'
          },
        },
        {
          path: '/entrust',
          name: 'entrust',
          component: entrust,
        },
        {
          path: '/entrustcz',
          name: 'entrustcz',
          component: entrustcz,
        },
        {
          path: '/entrustcs',
          name: 'entrustcs',
          component: entrustcs,
        },
        {
          path: '/entrustzf',
          name: 'entrustzf',
          component: entrustzf,
        },
        {
          path: '/entrustmf',
          name: 'entrustmf',
          component: entrustmf,
        },
        {
          path: '/aboutUs1',
          name: 'aboutUs1',
          component: aboutUs1,
          children: [
            {
              path: '/aboutus',
              name: 'aboutus',
              component: aboutus,
            },
          ]
        },

      ]
    },

  ]
})

router.beforeEach((to,from,next) => {
  if (to.meta.title) {
    document.title ='【成都'+to.meta.title+'出租|出售】-城市好房网' ;
  }
  next();
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js